import React from 'react';
import { Modal } from 'antd';
import EditCompanyDefaultWageForm from './EditCompanyDefaultWageForm';
import { useGeneralStore } from '../../store/slices/createGeneralSlice';
import { useNonePersistedStore } from '../../store/non-persisted-store';

export default function EditCompanyWage() {
    const { wages } = useNonePersistedStore()
    const general = useGeneralStore();
    const visible = general.view.editCompanyDefaultAgent;
    const selectedCompany = wages.single;

    return (
        <Modal
            width={800}
            title="بروزرسانی اطلاعات شرکت"
            className="custom-table"
            visible={visible}
            footer={false}
            onCancel={() => general.ToggleEditCompanyDefaultAgentModal()}>
            <EditCompanyDefaultWageForm
                onSubmit={() => {
                    general.ToggleEditCompanyDefaultAgentModal();
                    general.NotifSuccess('اطلاعات شرکت بیمه با موفقیت بروزرسانی شد');
                }}
                company={selectedCompany}
            />
        </Modal>
    )
}
